export const slbFooter = {
    footer: {
        copy: "Copyright © 2023 SLB. All rights reserved."
    }    
};